/* CACHE-BUST-1778909488 */
/* SpectraPure theme.js — global behaviors
 * Mobile drawer, mega-menu, search, mini-cart, accordion.
 * Vanilla ES6+, no dependencies.
 */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Drawer controller ---------- */
  const Drawer = {
    open(id) {
      const drawer = document.getElementById(id);
      if (!drawer) return;
      drawer.setAttribute('data-open', 'true');
      const overlay = drawer.previousElementSibling;
      if (overlay && overlay.classList.contains('c-drawer__overlay')) overlay.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      const focusable = drawer.querySelector('button, a, input, [tabindex]');
      if (focusable) focusable.focus();
      drawer.dispatchEvent(new CustomEvent('drawer:open'));
    },
    close(id) {
      const drawer = document.getElementById(id);
      if (!drawer) return;
      drawer.setAttribute('data-open', 'false');
      const overlay = drawer.previousElementSibling;
      if (overlay && overlay.classList.contains('c-drawer__overlay')) overlay.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
      drawer.dispatchEvent(new CustomEvent('drawer:close'));
    },
    closeAll() {
      $$('.c-drawer[data-open="true"]').forEach(d => this.close(d.id));
    }
  };
  window.SpectraDrawer = Drawer;

  /* ---------- Wire drawer buttons ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      Drawer.open(opener.getAttribute('data-drawer-open'));
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      const drawerEl = closer.closest('.c-drawer');
      if (drawerEl) Drawer.close(drawerEl.id);
      else Drawer.closeAll();
      return;
    }
    if (e.target.classList && e.target.classList.contains('c-drawer__overlay')) {
      Drawer.closeAll();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') Drawer.closeAll();
  });

  /* ---------- Mega menu (hover/focus) ---------- */
  $$('[data-megamenu-trigger]').forEach((trigger) => {
    const id = trigger.getAttribute('data-megamenu-trigger');
    const menu = document.getElementById(id);
    if (!menu) return;
    let timer;

    const open = () => {
      clearTimeout(timer);
      $$('[data-megamenu]').forEach(m => { if (m !== menu) m.setAttribute('data-open', 'false'); });
      $$('[data-megamenu-trigger]').forEach(t => { if (t !== trigger) t.setAttribute('aria-expanded', 'false'); });
      menu.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      timer = setTimeout(() => {
        menu.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
      }, 150);
    };

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);
    trigger.addEventListener('mouseleave', close);
    menu.addEventListener('mouseenter', () => clearTimeout(timer));
    menu.addEventListener('mouseleave', close);

    trigger.addEventListener('click', (e) => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        menu.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        e.preventDefault();
        open();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menu.getAttribute('data-open') === 'true') {
        menu.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });
  });

  // close mega menu on outside click
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-megamenu]') && !e.target.closest('[data-megamenu-trigger]')) {
      $$('[data-megamenu]').forEach(m => m.setAttribute('data-open', 'false'));
      $$('[data-megamenu-trigger]').forEach(t => t.setAttribute('aria-expanded', 'false'));
    }
  });

  /* ---------- Mobile nav expand groups ---------- */
  $$('.c-mobile-nav__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const sub = btn.nextElementSibling;
      if (!sub) return;
      const open = sub.getAttribute('data-open') === 'true';
      sub.setAttribute('data-open', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  /* ---------- Accordion ---------- */
  $$('.c-accordion').forEach(acc => {
    const single = acc.dataset.single === 'true';
    $$('.c-accordion__trigger', acc).forEach(trigger => {
      trigger.addEventListener('click', () => {
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        if (single) {
          $$('.c-accordion__trigger', acc).forEach(t => {
            t.setAttribute('aria-expanded', 'false');
            const p = t.nextElementSibling;
            if (p) p.setAttribute('data-open', 'false');
          });
        }
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        const panel = trigger.nextElementSibling;
        if (panel) panel.setAttribute('data-open', expanded ? 'false' : 'true');
      });
    });
  });

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(tabs => {
    const buttons = $$('[role="tab"]', tabs);
    const panels = $$('[role="tabpanel"]', tabs);
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.setAttribute('aria-selected', 'false'));
        panels.forEach(p => p.hidden = true);
        btn.setAttribute('aria-selected', 'true');
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
      });
    });
  });

  /* ---------- Mini cart fetch ---------- */
  async function refreshMiniCart() {
    try {
      const res = await fetch(`${window.routes.cart_url}.js`, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const count = cart.item_count;
      $$('[data-cart-count]').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
      const miniBody = $('[data-mini-cart-body]');
      if (miniBody) renderMiniCart(cart, miniBody);
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (e) { /* silent */ }
  }

  function renderMiniCart(cart, container) {
    if (cart.item_count === 0) {
      container.innerHTML = `<p class="u-text-muted u-text-center" style="padding:32px 0;">Your cart is empty.</p>`;
      const footer = $('[data-mini-cart-footer]');
      if (footer) footer.style.display = 'none';
      return;
    }
    const footer = $('[data-mini-cart-footer]');
    if (footer) footer.style.display = '';
    const lines = cart.items.map(item => `
      <div class="c-mini-cart-line">
        <img class="c-mini-cart-line__img" src="${item.image || ''}" alt="${item.product_title}" width="64" height="64" loading="lazy">
        <div>
          <div class="c-mini-cart-line__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="u-text-muted" style="font-size:12px;font-family:var(--font-mono);">${item.variant_title}</div>` : ''}
          <div style="font-size:12px;color:var(--color-text-muted);">Qty ${item.quantity}</div>
        </div>
        <div class="c-mini-cart-line__price">${formatMoney(item.final_line_price)}</div>
      </div>
    `).join('');
    const total = `<div class="c-cart-summary__row c-cart-summary__row--total"><span>Subtotal</span><span class="c-cart-summary__total-value">${formatMoney(cart.total_price)}</span></div>`;
    container.innerHTML = lines + total;
  }

  function formatMoney(cents) {
    const v = (cents / 100).toFixed(2);
    return `$${v}`;
  }
  window.SpectraFormatMoney = formatMoney;
  window.SpectraRefreshCart = refreshMiniCart;

  /* ---------- Add to cart (delegated) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');
    const originalLabel = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
    }
    try {
      const formData = new FormData(form);
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });
      const data = await res.json();
      if (!res.ok) {
        showNotice(data.description || data.message || 'Could not add to cart.', 'danger');
      } else {
        await refreshMiniCart();
        Drawer.open('mini-cart-drawer');
      }
    } catch (err) {
      showNotice('Network error. Please try again.', 'danger');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
      }
    }
  });

  function showNotice(msg, level = 'info') {
    let host = $('#notice-host');
    if (!host) {
      host = document.createElement('div');
      host.id = 'notice-host';
      host.style.cssText = 'position:fixed;top:16px;right:16px;z-index:200;display:flex;flex-direction:column;gap:8px;max-width:340px;';
      document.body.appendChild(host);
    }
    const el = document.createElement('div');
    el.className = `c-notice c-notice--${level}`;
    el.setAttribute('role', 'status');
    el.textContent = msg;
    host.appendChild(el);
    setTimeout(() => el.remove(), 4500);
  }
  window.SpectraNotice = showNotice;

  /* ---------- Search drawer prefetch ---------- */
  const searchInput = $('[data-search-input]');
  const searchResults = $('[data-search-results]');
  if (searchInput && searchResults) {
    let lastQuery = '';
    let timer;
    searchInput.addEventListener('input', () => {
      const q = searchInput.value.trim();
      clearTimeout(timer);
      if (!q || q === lastQuery) return;
      timer = setTimeout(async () => {
        lastQuery = q;
        try {
          const url = `${window.routes.predictive_search_url || '/search/suggest'}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
          const res = await fetch(url);
          const data = await res.json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (products.length === 0) {
            searchResults.innerHTML = `<p class="u-text-muted" style="padding:16px;">No products match "${escapeHtml(q)}".</p>`;
            return;
          }
          searchResults.innerHTML = products.map(p => `
            <a class="c-mini-cart-line" href="${p.url}" style="text-decoration:none;color:inherit;">
              <img class="c-mini-cart-line__img" src="${p.featured_image && p.featured_image.url ? p.featured_image.url : ''}" alt="${escapeHtml(p.title)}" width="64" height="64" loading="lazy">
              <div>
                <div class="c-mini-cart-line__title">${escapeHtml(p.title)}</div>
                <div class="u-text-muted" style="font-size:12px;">${p.vendor || ''}</div>
              </div>
              <div class="c-mini-cart-line__price">${p.price || ''}</div>
            </a>
          `).join('');
        } catch (err) { /* silent */ }
      }, 200);
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }
  window.SpectraEscape = escapeHtml;

  /* ---------- Sticky header shadow ---------- */
  const header = $('.c-header');
  if (header) {
    let scrolled = false;
    window.addEventListener('scroll', () => {
      const isScrolled = window.scrollY > 8;
      if (isScrolled !== scrolled) {
        scrolled = isScrolled;
        header.style.boxShadow = scrolled ? 'var(--shadow-1)' : 'none';
      }
    }, { passive: true });
  }

  /* ---------- Init: cart count on load ---------- */
  refreshMiniCart();
})();

/* ---------- System Finder Quiz ---------- */
(function () {
  const root = document.querySelector('[data-quiz-root]');
  if (!root) return;
  const rulesEl = root.querySelector('[data-quiz-rules]');
  let rules = [];
  try { rules = JSON.parse(rulesEl.textContent); } catch (e) { rules = []; }

  const state = { step: 1, answers: {} };
  const panels = root.querySelectorAll('[data-step]');
  const dots = root.querySelectorAll('[data-dot]');
  const backBtn = root.querySelector('[data-quiz-back]');
  const nextBtn = root.querySelector('[data-quiz-next]');
  const resultEl = root.querySelector('[data-quiz-result]');
  const restartBtn = root.querySelector('[data-quiz-restart]');

  function show(step) {
    panels.forEach(p => p.setAttribute('data-active', p.getAttribute('data-step') === String(step) ? 'true' : 'false'));
    dots.forEach(d => {
      const n = parseInt(d.getAttribute('data-dot'), 10);
      d.classList.remove('c-quiz__step-dot--active', 'c-quiz__step-dot--done');
      if (typeof step === 'number') {
        if (n === step) d.classList.add('c-quiz__step-dot--active');
        else if (n < step) d.classList.add('c-quiz__step-dot--done');
      } else {
        d.classList.add('c-quiz__step-dot--done');
      }
    });
    backBtn.disabled = step === 1 || step === 'result';
    nextBtn.disabled = step === 'result' || !state.answers[fieldFor(step)];
    nextBtn.style.display = step === 'result' ? 'none' : '';
    backBtn.style.display = step === 'result' ? 'none' : '';
  }

  function fieldFor(step) {
    return { 1: 'source', 2: 'application', 3: 'gpd', 4: 'budget' }[step];
  }

  root.querySelectorAll('.c-quiz__options').forEach(group => {
    const field = group.getAttribute('data-options');
    group.querySelectorAll('.c-quiz__option').forEach(opt => {
      opt.addEventListener('click', () => {
        group.querySelectorAll('.c-quiz__option').forEach(o => o.setAttribute('aria-pressed', 'false'));
        opt.setAttribute('aria-pressed', 'true');
        state.answers[field] = opt.getAttribute('data-value');
        nextBtn.disabled = false;
      });
    });
  });

  nextBtn.addEventListener('click', () => {
    if (state.step < 4) {
      state.step += 1;
      show(state.step);
    } else {
      computeMatch();
    }
  });
  backBtn.addEventListener('click', () => {
    if (state.step > 1) {
      state.step -= 1;
      show(state.step);
    }
  });
  restartBtn.addEventListener('click', (e) => {
    e.preventDefault();
    state.step = 1;
    state.answers = {};
    root.querySelectorAll('.c-quiz__option[aria-pressed="true"]').forEach(o => o.setAttribute('aria-pressed', 'false'));
    show(1);
  });

  function matchRule(rule) {
    return (rule.source === '*' || rule.source === state.answers.source) &&
           (rule.application === '*' || rule.application === state.answers.application) &&
           (rule.gpd === '*' || rule.gpd === state.answers.gpd) &&
           (rule.budget === '*' || rule.budget === state.answers.budget);
  }

  function score(rule) {
    let s = 0;
    if (rule.source !== '*') s++;
    if (rule.application !== '*') s++;
    if (rule.gpd !== '*') s++;
    if (rule.budget !== '*') s++;
    return s;
  }

  function isValid(p) {
    return p && p.title && p.url && p.title !== 'null' && p.url !== 'null';
  }

  function computeMatch() {
    const matches = rules.filter(matchRule).sort((a, b) => score(b) - score(a));
    const best = matches[0];
    if (!best || !isValid(best.match)) {
      resultEl.innerHTML = '<p class="u-text-muted">No exact match yet. <a href="/pages/contact-us">Talk to an engineer</a> and we\'ll spec a system around your conditions.</p>';
    } else {
      const validAlts = (best.alternates || []).filter(isValid);
      const altsHtml = validAlts.map(a =>
        `<li><a href="${a.url}">${a.title}</a> &mdash; ${a.price}</li>`
      ).join('');
      resultEl.innerHTML = `
        <div class="c-quiz__match">
          ${best.match.image ? `<img src="${best.match.image}" alt="${best.match.title}" width="120" height="120" style="float:right;margin-left:12px;">` : ''}
          <h4 style="margin:0 0 4px;font-size:18px;">${best.match.title}</h4>
          <p style="margin:0 0 8px;font-family:var(--font-mono);">${best.match.price || ''}</p>
          <p style="margin:0 0 12px;color:var(--color-text-muted);font-size:14px;">${best.reason || ''}</p>
          <a class="c-button c-button--primary" href="${best.match.url}">View this system</a>
        </div>
        ${altsHtml ? `<div><p style="font-weight:600;font-size:13px;text-transform:uppercase;letter-spacing:0.06em;color:var(--color-text-muted);margin:0 0 6px;">Also consider</p><ul style="margin:0;padding-left:20px;font-size:14px;">${altsHtml}</ul></div>` : ''}
        <a class="c-button c-button--ghost" href="/pages/contact-us">Talk to an engineer instead</a>
      `;
    }
    state.step = 'result';
    show('result');
  }

  show(1);
})();

/* ---------- TCO Calculator ---------- */
(function () {
  const root = document.querySelector('[data-tco-root]');
  if (!root) return;
  const gpdInput = root.querySelector('[data-tco-gpd]');
  const cols = Array.from(root.querySelectorAll('[data-tco-col]'));
  const years = 4;

  function fmt(v) {
    return '$' + Math.round(v).toLocaleString('en-US');
  }

  function recalc() {
    const gpd = Math.max(0, parseFloat(gpdInput.value) || 0);
    let max = 0;
    const totals = cols.map(c => {
      const sysPrice = parseFloat(c.getAttribute('data-sys-price')) || 0;
      const filtersAnnual = parseFloat(c.getAttribute('data-filters-annual')) || 0;
      const wasteRatio = parseFloat(c.getAttribute('data-waste-ratio')) || 0;
      const total = sysPrice + (filtersAnnual * years);
      // wasted water: gpd * 365 * years * wasteRatio
      const wasted = gpd * 365 * years * wasteRatio;
      if (total > max) max = total;
      return { total, wasted };
    });

    cols.forEach((c, i) => {
      const tot = c.querySelector('[data-tco-total]');
      const wst = c.querySelector('[data-tco-wasted]');
      const bar = c.querySelector('[data-tco-bar]');
      if (tot) tot.textContent = fmt(totals[i].total);
      if (wst) wst.textContent = Math.round(totals[i].wasted).toLocaleString('en-US') + ' gal wasted';
      if (bar) bar.style.width = max > 0 ? ((totals[i].total / max) * 100).toFixed(1) + '%' : '0%';
    });
  }
  if (gpdInput) gpdInput.addEventListener('input', recalc);
  recalc();
})();

/* ============================================================
   HERO TANK V2 — Canvas fish engine, caustics, bubbles
   IIFE module — no external deps, <15 KB unminified.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  const canvas = document.getElementById('heroTankCanvas');
  if (!canvas) return;

  const PRM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobile = window.innerWidth < 900;

  const ctx = canvas.getContext('2d');
  let W = 0, H = 0;

  // ── Cursor state ──────────────────────────────────────────
  let cursorX = 0.5, cursorY = 0.5; // normalised 0..1
  let cursorActive = false;
  let autoPanT = 0; // for mobile slow auto-pan

  // ── Resize handler ────────────────────────────────────────
  function resize() {
    const rect = canvas.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = rect.width;
    H = rect.height;
    canvas.width  = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    ctx.scale(dpr, dpr);
  }
  const ro = new ResizeObserver(resize);
  ro.observe(canvas);
  resize();

  // ── Cursor / touch tracking ────────────────────────────────
  const tankWrap = canvas.closest('.c-hero__tank-wrap');
  const heroSection = canvas.closest('.c-hero');
  // Track the cursor over the WHOLE hero (including the text column), so the fish react
  // when the user moves their mouse anywhere in the hero — not just over the tank.
  const tracker = heroSection || tankWrap;
  if (tracker && tankWrap && !PRM) {
    tracker.addEventListener('mousemove', (e) => {
      const r = tankWrap.getBoundingClientRect();
      // Project the cursor onto the tank's coordinate space
      let nx = (e.clientX - r.left) / r.width;
      let ny = (e.clientY - r.top)  / r.height;
      // Clamp slightly past the edges so fish chase up to the wall
      nx = Math.max(-0.15, Math.min(1.15, nx));
      ny = Math.max(-0.15, Math.min(1.15, ny));
      cursorX = nx;
      cursorY = ny;
      cursorActive = true;
    });
    tracker.addEventListener('mouseleave', () => { cursorActive = false; });
    tracker.addEventListener('touchmove', (e) => {
      if (!e.touches[0]) return;
      const r = tankWrap.getBoundingClientRect();
      cursorX = Math.max(-0.15, Math.min(1.15, (e.touches[0].clientX - r.left) / r.width));
      cursorY = Math.max(-0.15, Math.min(1.15, (e.touches[0].clientY - r.top)  / r.height));
      cursorActive = true;
    }, { passive: true });
    tracker.addEventListener('touchend', () => { cursorActive = false; });
  }

  // ── Fish definitions (SVG-path style, 8 fish) ─────────────
  // Each fish is a set of Canvas path drawing commands.
  // All coordinates are in a local unit box [-1..1, -0.5..0.5].
  // drawFish(ctx, scale, colorFill, colorFin, facing) where
  // facing = 1 (right) or -1 (left, via ctx.scale(-1,1)).

  // Palette: 2 accent moments, rest are deep-water neutral tones
  const FISH_DEFS = [
    // 0 — sleek tang (primary blue)
    { bodyColor: '#2a7bb8', finColor: '#1a5a8a', accentColor: '#5aaee0', rainbow: false },
    // 1 — small chromis (teal-green)
    { bodyColor: '#2e9470', finColor: '#1a6650', accentColor: '#50c090', rainbow: false },
    // 2 — damsel (slate-blue)
    { bodyColor: '#3a5a8c', finColor: '#253d61', accentColor: '#6080b0', rainbow: false },
    // 3 — wrasse (muted blue-grey)
    { bodyColor: '#4a6878', finColor: '#2e4858', accentColor: '#7090a0', rainbow: false },
    // 4 — clownfish-shape (warm amber — ACCENT #1: 1 fish only)
    { bodyColor: '#d4853a', finColor: '#b06020', accentColor: '#f0a060', rainbow: false },
    // 5 — goby (desaturated teal)
    { bodyColor: '#326870', finColor: '#1e4a50', accentColor: '#50909a', rainbow: false },
    // 6 — firefish (neutral grey-blue)
    { bodyColor: '#506888', finColor: '#304858', accentColor: '#7090b0', rainbow: false },
    // 7 — "spectrum" rare fish (ACCENT #2: very subtle brand rainbow) — only 1 instance
    { bodyColor: '#2a5878', finColor: '#1a3858', accentColor: '#60a8c8', rainbow: true },
  ];

  // Draw one fish at origin (0,0), facing right, within ~(-1..1) x (-0.5..0.5) unit space.
  // Scale it with ctx.save/scale beforehand.
  function drawFishShape(cx, def, tailPhase, scale) {
    const { bodyColor, finColor, accentColor, rainbow } = def;
    const S = scale;

    // Tail wag offset (subtle):
    const tw = Math.sin(tailPhase) * 0.18 * S;

    // Body (ellipse-like path)
    cx.beginPath();
    cx.moveTo(-S * 0.9, 0);
    cx.bezierCurveTo(-S * 0.9, -S * 0.32, S * 0.55, -S * 0.32, S * 0.72, -S * 0.04);
    cx.bezierCurveTo(S * 0.85, S * 0.04, S * 0.85, S * 0.12, S * 0.72, S * 0.04);
    cx.bezierCurveTo(S * 0.55, S * 0.32, -S * 0.9, S * 0.32, -S * 0.9, 0);
    cx.closePath();
    if (rainbow) {
      // Subtle spectrum gradient on the special fish
      const grd = cx.createLinearGradient(-S * 0.9, 0, S * 0.72, 0);
      grd.addColorStop(0,    '#E63B1E44');
      grd.addColorStop(0.25, '#F5822044');
      grd.addColorStop(0.5,  '#2EAA4E44');
      grd.addColorStop(0.75, '#0DAEDD44');
      grd.addColorStop(1,    '#2a5878');
      // Blend: base color + gradient overlay
      cx.fillStyle = bodyColor;
      cx.fill();
      cx.fillStyle = grd;
      cx.fill();
    } else {
      cx.fillStyle = bodyColor;
      cx.fill();
    }

    // Lateral stripe / sheen
    cx.beginPath();
    cx.moveTo(-S * 0.5, -S * 0.04);
    cx.bezierCurveTo(-S * 0.2, -S * 0.20, S * 0.3, -S * 0.20, S * 0.50, -S * 0.04);
    cx.strokeStyle = accentColor + '55';
    cx.lineWidth = S * 0.10;
    cx.stroke();

    // Dorsal fin
    cx.beginPath();
    cx.moveTo(-S * 0.2, -S * 0.30);
    cx.bezierCurveTo(S * 0.0, -S * 0.55, S * 0.35, -S * 0.50, S * 0.55, -S * 0.28);
    cx.bezierCurveTo(S * 0.30, -S * 0.28, -S * 0.10, -S * 0.30, -S * 0.2, -S * 0.30);
    cx.closePath();
    cx.fillStyle = finColor + 'cc';
    cx.fill();

    // Pectoral fin
    cx.beginPath();
    cx.moveTo(S * 0.1, S * 0.0);
    cx.bezierCurveTo(S * 0.25, S * 0.28, S * 0.55, S * 0.32, S * 0.60, S * 0.20);
    cx.bezierCurveTo(S * 0.45, S * 0.10, S * 0.20, S * 0.06, S * 0.1, S * 0.0);
    cx.closePath();
    cx.fillStyle = finColor + 'aa';
    cx.fill();

    // Tail (caudal fin) with wag
    cx.beginPath();
    cx.moveTo(-S * 0.85, 0);
    cx.bezierCurveTo(-S * 1.05, -S * 0.38 + tw, -S * 1.30, -S * 0.42 + tw, -S * 1.35, -S * 0.20 + tw * 0.6);
    cx.bezierCurveTo(-S * 1.35, S * 0.0 + tw * 0.4, -S * 1.20, S * 0.10 + tw * 0.3, -S * 0.85, 0);
    cx.moveTo(-S * 0.85, 0);
    cx.bezierCurveTo(-S * 1.05, S * 0.38 - tw, -S * 1.30, S * 0.42 - tw, -S * 1.35, S * 0.20 - tw * 0.6);
    cx.bezierCurveTo(-S * 1.35, S * 0.0 - tw * 0.4, -S * 1.20, -S * 0.10 - tw * 0.3, -S * 0.85, 0);
    cx.fillStyle = finColor + 'bb';
    cx.fill();

    // Eye
    cx.beginPath();
    cx.arc(S * 0.45, -S * 0.10, S * 0.085, 0, Math.PI * 2);
    cx.fillStyle = '#0a1820';
    cx.fill();
    cx.beginPath();
    cx.arc(S * 0.47, -S * 0.12, S * 0.028, 0, Math.PI * 2);
    cx.fillStyle = 'rgba(255,255,255,0.75)';
    cx.fill();
  }

  // ── Fish instances ─────────────────────────────────────────
  const FISH_COUNT = isMobile ? 3 : 7;

  function makeFish(i) {
    const defIdx = i % FISH_DEFS.length;
    // Last fish gets the spectrum one if not mobile
    const finalDefIdx = (!isMobile && i === FISH_COUNT - 1) ? 7 : defIdx;
    return {
      def: FISH_DEFS[finalDefIdx],
      // position in canvas units (0..W, 0..H)
      x: Math.random() * W,
      y: H * 0.15 + Math.random() * H * 0.60, // avoid top/bottom edges
      // velocity
      vx: (Math.random() * 1.2 + 0.4) * (Math.random() < 0.5 ? 1 : -1),
      vy: (Math.random() * 0.4 - 0.2),
      // scale relative to canvas height
      scale: (isMobile ? 0.055 : 0.048 + Math.random() * 0.022) * H,
      // tail animation phase (offset per fish)
      tailPhase: Math.random() * Math.PI * 2,
      tailSpeed: 2.8 + Math.random() * 1.4,
      // idle sinusoidal vertical drift
      wobblePhase: Math.random() * Math.PI * 2,
      wobbleAmp: 0.08 + Math.random() * 0.10,
      wobbleSpeed: 0.5 + Math.random() * 0.5,
      // cursor-following state
      targetX: -1, // -1 = ignore cursor
      targetY: -1,
      seekWeight: 0.6 + Math.random() * 0.35, // how eagerly this fish follows
      // max follow distance (in px) — fish won't teleport to cursor
      maxSeekDist: (0.60 + Math.random() * 0.25) * Math.max(W, H),
      // depth layer (0=back, 1=front) — affects opacity & scale
      depth: Math.random(),
    };
  }

  let fish = Array.from({ length: FISH_COUNT }, (_, i) => makeFish(i));

  // Recalculate fish scales on resize
  function rescaleFish() {
    fish.forEach(f => {
      f.scale = (isMobile ? 0.055 : 0.048 + Math.random() * 0.022) * H;
      f.maxSeekDist = (0.60 + Math.random() * 0.25) * Math.max(W, H);
    });
  }
  const _origResize = resize;
  // Re-hook resize to also rescale fish
  const roFish = new ResizeObserver(() => { _origResize(); if (H > 0) rescaleFish(); });
  roFish.observe(canvas);

  // ── Bubble system ──────────────────────────────────────────
  const BUBBLE_MAX = isMobile ? 4 : 8;
  const bubbles = [];

  function spawnBubble() {
    if (bubbles.length >= BUBBLE_MAX) return;
    bubbles.push({
      x: W * (0.1 + Math.random() * 0.8),
      y: H * 0.88 + Math.random() * H * 0.10,
      r: 3 + Math.random() * 6,
      vy: -(0.35 + Math.random() * 0.55),
      vx: (Math.random() - 0.5) * 0.3,
      opacity: 0,
      fadeIn: true,
      life: 0,
      maxLife: 180 + Math.random() * 160,
    });
  }

  let bubbleTimer = 0;
  const BUBBLE_INTERVAL = isMobile ? 110 : 70;

  // ── Caustic blobs ──────────────────────────────────────────
  // Simple: 4-6 soft radial gradient blobs that drift slowly
  const CAUSTIC_COUNT = isMobile ? 3 : 5;
  const caustics = Array.from({ length: CAUSTIC_COUNT }, () => ({
    x: Math.random(),  // normalised
    y: Math.random() * 0.55,
    r: 0.12 + Math.random() * 0.18,
    vx: (Math.random() - 0.5) * 0.00035,
    vy: (Math.random() - 0.5) * 0.00025,
    phase: Math.random() * Math.PI * 2,
    speed: 0.004 + Math.random() * 0.003,
    // tint: mostly white-blue, 1 gets a faint spectrum hue
    hue: Math.random() < 0.2 ? (Math.random() * 60 + 170) : 200,
  }));

  // ── Background layers ──────────────────────────────────────
  function drawBackground(t) {
    // Water column gradient: deep midnight → mid teal → lighter near surface
    const bg = ctx.createLinearGradient(0, 0, 0, H);
    bg.addColorStop(0,    '#051624'); // surface (dark — light comes from above as caustics)
    bg.addColorStop(0.18, '#071f38');
    bg.addColorStop(0.55, '#082b4d');
    bg.addColorStop(0.85, '#094060');
    bg.addColorStop(1,    '#071830');
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, W, H);

    // Depth parallax: subtle mid-water lighter band
    const midBand = ctx.createLinearGradient(0, H * 0.15, 0, H * 0.5);
    midBand.addColorStop(0, 'rgba(13,174,221,0.04)');
    midBand.addColorStop(1, 'rgba(13,174,221,0)');
    ctx.fillStyle = midBand;
    ctx.fillRect(0, 0, W, H * 0.5);
  }

  function drawRocks(t) {
    // Silhouetted rocks at bottom-left and bottom-right
    ctx.fillStyle = '#040e1a';

    // Left rock cluster
    ctx.beginPath();
    ctx.moveTo(0, H);
    ctx.bezierCurveTo(W * 0.04, H * 0.82, W * 0.08, H * 0.78, W * 0.14, H * 0.84);
    ctx.bezierCurveTo(W * 0.18, H * 0.88, W * 0.22, H * 0.80, W * 0.28, H * 0.86);
    ctx.bezierCurveTo(W * 0.30, H * 0.90, W * 0.18, H, 0, H);
    ctx.closePath();
    ctx.fill();

    // Right rock cluster
    ctx.beginPath();
    ctx.moveTo(W, H);
    ctx.bezierCurveTo(W * 0.96, H * 0.80, W * 0.90, H * 0.76, W * 0.84, H * 0.84);
    ctx.bezierCurveTo(W * 0.80, H * 0.88, W * 0.75, H * 0.78, W * 0.70, H * 0.86);
    ctx.bezierCurveTo(W * 0.68, H * 0.92, W * 0.80, H, W, H);
    ctx.closePath();
    ctx.fill();

    // Sand / substrate strip
    const sand = ctx.createLinearGradient(0, H * 0.88, 0, H);
    sand.addColorStop(0, '#0d2035');
    sand.addColorStop(0.4, '#122840');
    sand.addColorStop(1, '#091e30');
    ctx.fillStyle = sand;
    ctx.fillRect(0, H * 0.89, W, H * 0.11);

    // Sand grain texture — tiny dots
    ctx.fillStyle = 'rgba(100,160,200,0.07)';
    for (let sx = 0; sx < W; sx += 8) {
      for (let sy = H * 0.90; sy < H; sy += 5) {
        if (Math.abs(Math.sin(sx * 17 + sy * 31)) > 0.7) {
          ctx.fillRect(sx, sy, 1.5, 1);
        }
      }
    }

    // Background kelp / plant silhouettes (left side)
    drawPlant(W * 0.08, H * 0.90, H * 0.45, 0.6, t * 0.3);
    drawPlant(W * 0.14, H * 0.90, H * 0.32, 0.5, t * 0.25 + 1.2);
    // Right side plants
    drawPlant(W * 0.86, H * 0.90, H * 0.42, 0.6, t * 0.28 + 2.1);
    drawPlant(W * 0.92, H * 0.90, H * 0.28, 0.5, t * 0.22 + 0.8);
  }

  function drawPlant(baseX, baseY, height, opacity, t) {
    ctx.save();
    ctx.globalAlpha = opacity * 0.55;
    // Stem — sinuous bezier
    const sway = Math.sin(t) * 6;
    ctx.beginPath();
    ctx.moveTo(baseX, baseY);
    ctx.bezierCurveTo(
      baseX + sway * 0.3, baseY - height * 0.33,
      baseX + sway * 0.7, baseY - height * 0.66,
      baseX + sway, baseY - height
    );
    ctx.lineWidth = 3;
    ctx.strokeStyle = '#0d2535';
    ctx.stroke();
    // Fronds
    const frondCount = 4;
    for (let f = 0; f < frondCount; f++) {
      const py = baseY - height * ((f + 1) / (frondCount + 1));
      const px = baseX + sway * ((f + 1) / (frondCount + 1));
      const dir = f % 2 === 0 ? 1 : -1;
      const fLen = height * (0.15 + f * 0.04);
      ctx.beginPath();
      ctx.moveTo(px, py);
      ctx.bezierCurveTo(
        px + dir * fLen * 0.5, py - fLen * 0.3,
        px + dir * fLen * 0.9, py - fLen * 0.5,
        px + dir * fLen, py - fLen * 0.2
      );
      ctx.lineWidth = 2;
      ctx.strokeStyle = '#112a3a';
      ctx.stroke();
    }
    ctx.restore();
  }

  function drawCaustics(t) {
    ctx.save();
    ctx.globalCompositeOperation = 'screen';
    caustics.forEach((c, idx) => {
      // Drift
      c.x += c.vx;
      c.y += c.vy;
      // Bounce softly
      if (c.x < 0 || c.x > 1) c.vx *= -1;
      if (c.y < 0 || c.y > 0.6) c.vy *= -1;

      const pulse = 0.7 + 0.3 * Math.sin(t * c.speed + c.phase);
      const cx = c.x * W;
      const cy = c.y * H;
      const radius = c.r * Math.min(W, H) * pulse;

      const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, radius);
      // The spectrum fish caustics get a faint hue; others stay white-blue
      const hue = c.hue;
      g.addColorStop(0,   `hsla(${hue}, 70%, 85%, 0.09)`);
      g.addColorStop(0.5, `hsla(${hue}, 50%, 65%, 0.04)`);
      g.addColorStop(1,   'hsla(200, 60%, 60%, 0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(cx, cy, radius, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.restore();
  }

  function drawBubbles() {
    bubbles.forEach((b, idx) => {
      b.x += b.vx + Math.sin(b.life * 0.06) * 0.25;
      b.y += b.vy;
      b.life++;
      if (b.fadeIn && b.opacity < 0.8) b.opacity += 0.04;
      if (b.life > b.maxLife * 0.8) b.opacity -= 0.03;

      ctx.save();
      ctx.globalAlpha = Math.max(0, Math.min(0.8, b.opacity));
      // Bubble body
      const g = ctx.createRadialGradient(
        b.x - b.r * 0.3, b.y - b.r * 0.3, b.r * 0.05,
        b.x, b.y, b.r
      );
      g.addColorStop(0, 'rgba(255,255,255,0.85)');
      g.addColorStop(0.6, 'rgba(174,224,255,0.30)');
      g.addColorStop(1, 'rgba(13,174,221,0.05)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(b.x, b.y, b.r, 0, Math.PI * 2);
      ctx.fill();
      // Rim highlight
      ctx.strokeStyle = 'rgba(255,255,255,0.30)';
      ctx.lineWidth = 0.6;
      ctx.stroke();
      ctx.restore();
    });
    // Remove dead bubbles
    for (let i = bubbles.length - 1; i >= 0; i--) {
      if (bubbles[i].life >= bubbles[i].maxLife || bubbles[i].opacity <= 0) {
        bubbles.splice(i, 1);
      }
    }
  }

  function updateAndDrawFish(t, dt) {
    // Current cursor in canvas pixel space
    const cxPx = cursorX * W;
    const cyPx = cursorY * H;

    // For mobile: slow auto-pan
    if (isMobile || !cursorActive) {
      autoPanT += dt * 0.35;
    }

    fish.forEach((f, fi) => {
      // ── Cursor attraction ────────────────────────────────
      if (!PRM) {
        let targetVX = 0, targetVY = 0;
        if (cursorActive && !isMobile) {
          const dx = cxPx - f.x;
          const dy = cyPx - f.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < f.maxSeekDist && dist > 8) {
            // Fish actively swim toward the cursor — stronger pull when closer
            const t01 = 1 - dist / f.maxSeekDist;
            const strength = (0.35 + t01 * 0.85) * f.seekWeight * 0.09;
            targetVX = (dx / dist) * strength * 3.2;
            targetVY = (dy / dist) * strength * 2.6;
          }
        } else if (isMobile) {
          // Auto-pan: gentle sinusoidal drift target
          const panX = W * (0.3 + 0.4 * Math.sin(autoPanT * 0.6 + fi));
          const panY = H * (0.35 + 0.25 * Math.sin(autoPanT * 0.4 + fi * 1.3));
          const dx = panX - f.x;
          const dy = panY - f.y;
          targetVX = dx * 0.006;
          targetVY = dy * 0.005;
        }
        // Blend into current velocity with easing — faster when cursor is active
        const blend = (cursorActive && !isMobile) ? 0.12 : 0.04;
        f.vx += (targetVX - f.vx * 0.12) * blend;
        f.vy += (targetVY - f.vy * 0.12) * blend;
      }

      // ── Idle wobble ───────────────────────────────────────
      f.wobblePhase += dt * f.wobbleSpeed;
      f.vy += Math.sin(f.wobblePhase) * f.wobbleAmp * 0.008;

      // ── Speed clamping ────────────────────────────────────
      const spd = Math.sqrt(f.vx * f.vx + f.vy * f.vy);
      const maxSpd = 2.8;
      const minSpd = 0.3;
      if (spd > maxSpd) { f.vx *= maxSpd / spd; f.vy *= maxSpd / spd; }
      if (spd < minSpd && !cursorActive) {
        // gentle drift to maintain minimum speed
        const ang = f.wobblePhase;
        f.vx += Math.cos(ang) * 0.04;
      }

      // ── Vertical boundary ─────────────────────────────────
      const yMin = H * 0.08;
      const yMax = H * 0.82;
      if (f.y < yMin) { f.vy += 0.12; f.y = yMin; }
      if (f.y > yMax) { f.vy -= 0.12; f.y = yMax; }

      // ── Wrap horizontally ─────────────────────────────────
      if (f.x < -f.scale * 1.6) f.x = W + f.scale;
      if (f.x > W + f.scale * 1.6) f.x = -f.scale;

      // Damp vertical velocity
      f.vy *= 0.94;

      // ── Advance position ──────────────────────────────────
      f.x += f.vx;
      f.y += f.vy;

      // ── Tail wag ─────────────────────────────────────────
      f.tailPhase += dt * f.tailSpeed;

      // ── Depth-based opacity & scale ───────────────────────
      const depthOpacity = 0.60 + f.depth * 0.40;
      const depthScale   = 0.80 + f.depth * 0.22;

      // ── Facing hysteresis (prevents rapid flip = "spinning") ─
      if (f.facingRight === undefined) f.facingRight = f.vx >= 0;
      // Only flip when velocity is firmly in the opposite direction for a few frames
      const wantRight = f.vx >= 0;
      if (wantRight !== f.facingRight) {
        f.flipCounter = (f.flipCounter || 0) + dt;
        if (f.flipCounter > 12 && Math.abs(f.vx) > 0.35) {
          f.facingRight = wantRight;
          f.flipCounter = 0;
        }
      } else {
        f.flipCounter = 0;
      }

      // ── Tilt: clamp to avoid loop-the-loop appearance ────
      // Tilt only based on smooth vy/Math.max(|vx|, minDenom) and cap at ~22°
      const tiltRaw = Math.atan2(f.vy, Math.max(Math.abs(f.vx), 0.8)) * 0.35;
      const tiltMax = 0.38; // ~22 degrees
      const tilt = Math.max(-tiltMax, Math.min(tiltMax, tiltRaw));

      // ── Draw ─────────────────────────────────────────────
      ctx.save();
      ctx.globalAlpha = depthOpacity;
      ctx.translate(f.x, f.y);
      if (!f.facingRight) ctx.scale(-1, 1);
      ctx.rotate(tilt);
      drawFishShape(ctx, f.def, f.tailPhase, f.scale * depthScale);
      ctx.restore();
    });
  }

  // ── Main animation loop ────────────────────────────────────
  let lastTime = 0;
  let stopped = PRM;
  let rafId = null;

  function frame(ts) {
    if (stopped) return;
    const dt = Math.min((ts - lastTime) / 16.67, 3); // normalised to ~60fps
    lastTime = ts;

    const t = ts / 1000; // seconds

    // Clear
    ctx.clearRect(0, 0, W, H);

    // Draw layers back-to-front
    drawBackground(t);
    drawRocks(t);
    drawCaustics(t);

    // Bubbles spawn
    if (!PRM) {
      bubbleTimer++;
      if (bubbleTimer >= BUBBLE_INTERVAL) {
        spawnBubble();
        bubbleTimer = 0;
      }
      drawBubbles();
    }

    // Fish
    updateAndDrawFish(t, dt);

    rafId = requestAnimationFrame(frame);
  }

  // ── Intersection observer — pause when not visible ─────────
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !stopped) {
          if (!rafId) rafId = requestAnimationFrame(frame);
        } else {
          if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        }
      });
    }, { threshold: 0.05 });
    io.observe(canvas);
  }

  // Kick off
  if (!PRM) {
    rafId = requestAnimationFrame(frame);
  } else {
    // Reduced motion: draw one static frame (background + statue visible)
    drawBackground(0);
    drawRocks(0);
  }

  // Expose for debugging
  window.__heroTank = { fish, bubbles, caustics, stop: () => { stopped = true; if (rafId) cancelAnimationFrame(rafId); } };
})();

/* ============================================================
   SCROLL REVEAL — fade-up on enter viewport
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    document.querySelectorAll('.js-reveal').forEach((el) => el.classList.add('is-revealed'));
    return;
  }
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.js-reveal').forEach((el) => el.classList.add('is-revealed'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  /* Auto-tag every <section> below the hero as a reveal target */
  document.querySelectorAll('main > section:not(.c-hero), .c-section').forEach((sec, i) => {
    if (i === 0) return; // skip first (likely hero)
    sec.classList.add('js-reveal');
    io.observe(sec);
  });
  /* Also reveal anything pre-tagged */
  document.querySelectorAll('.js-reveal').forEach((el) => io.observe(el));
})();

/* ============ REWARDS HANDLER ============ */
/* [data-rewards-open] triggers route to the SpectraPoints rewards page.
   On pages where the Smile.io embed is loaded (product/cart/page/policy
   templates), the panel opens directly like a drawer.
   On pages without Smile loaded (homepage, collections), we navigate to
   /pages/rewards with ?open_rewards=1 so the panel auto-opens on arrival. */
(function () {
  'use strict';

  function isSmileReady() {
    return !!(window.SmileUI && typeof window.SmileUI.openPanel === 'function');
  }

  function openPanel(attempt) {
    attempt = attempt || 0;
    if (isSmileReady()) {
      try {
        window.SmileUI.openPanel({ data: { trigger: 'launcher' } });
        return true;
      } catch (e) {}
    }
    // Fallback: simulate user click on the floating launcher widget
    var launcherContainer = document.querySelector('.smile-launcher-frame-container');
    if (launcherContainer) {
      try {
        var rect = launcherContainer.getBoundingClientRect();
        var ev = new MouseEvent('click', {
          bubbles: true, cancelable: true, view: window,
          clientX: rect.left + rect.width / 2,
          clientY: rect.top + rect.height / 2
        });
        launcherContainer.dispatchEvent(ev);
        return true;
      } catch (e) {}
    }
    if (attempt < 16) {
      setTimeout(function () { openPanel(attempt + 1); }, 250);
    }
    return false;
  }

  // Open trigger handler
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-rewards-open]');
    if (!trigger) return;
    e.preventDefault();

    if (isSmileReady() || document.querySelector('.smile-launcher-frame-container')) {
      // Smile is on this page — open panel directly (drawer slides in)
      openPanel(0);
    } else {
      // Smile isn't loaded on this template — navigate to rewards page
      // and signal it to auto-open the panel on arrival.
      window.location.href = '/pages/rewards?open_rewards=1';
    }
  });

  // Auto-open on arrival if ?open_rewards=1 is in URL
  function maybeAutoOpen() {
    try {
      var qs = window.location.search;
      if (qs.indexOf('open_rewards=1') === -1) return;
      // Wait for Smile to be ready then open
      openPanel(0);
      // Clean the query string so refresh doesn't re-trigger
      if (window.history && window.history.replaceState) {
        var cleanUrl = window.location.pathname + window.location.hash;
        window.history.replaceState({}, document.title, cleanUrl);
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeAutoOpen);
  } else {
    maybeAutoOpen();
  }
})();

/* ============ COLLECTION FILTERS DRAWER (mobile) ============ */
(function () {
  'use strict';
  function setOpen(open) {
    var drawer = document.querySelector('[data-filters-drawer]');
    if (!drawer) return;
    drawer.setAttribute('data-open', open ? 'true' : 'false');
  }
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-filters-open]')) {
      e.preventDefault(); setOpen(true);
    } else if (e.target.closest('[data-filters-close]')) {
      e.preventDefault(); setOpen(false);
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') setOpen(false);
  });
})();
